import React, { useContext } from "react";
import {
  Button,
  Text,
  LegacyCard as Card,
  ColorPicker,
  Collapsible,
  Layout,
  InlineStack,
  TextField,
  BlockStack,
  Box,
} from "@shopify/polaris";

// import hoc
import { withErrorBoundary, withFeature } from "lib/hoc";

// import constant
import constant from "lib/constant/constant";
import { baseHelper } from "lib/helpers";

// import context
import { PrivateContext } from "lib/context";
import { BrandingContext } from "app/setup/modules/operator/features/branding/context/context";

const ButtonText = () => {
  const {
    color,
    errorMessage,
    handleChange,
    hex,
    // learnMore,
    resetDefault,
  } = useContext(BrandingContext);
  const { cms = () => {}, currentUser } = useContext(PrivateContext);
  const { updatedAt = "" } = currentUser || {};
  const { BUTTON_TEXT, DEFAULT_HEADER_COLOR, HEX, COLOR } = constant;

  return (
    <Collapsible open>
      <Layout.AnnotatedSection
        title={cms("section.buttonTextColor.title")}
        description={cms("section.buttonTextColor.description")}
      >
        <Card
          title={[
            cms("section.buttonTextColor.title"),
            updatedAt && (
              <Text as="span" tone="subdued">
                <Text variant="bodySm" as="p">{`${baseHelper.lastUpdateDate(updatedAt)}`}</Text>
              </Text>
            ),
          ]}
          // actions={[
          //   { content: "Learn more", onAction: () => learnMore(cms("section.buttonTextColor.title"), "TODO: ") },
          // ]}
        >
          <Card.Section>
            <BlockStack gap="2">{cms("section.buttonTextColor.subDescription")}</BlockStack>
            <br />
            <InlineStack align="space-between">
              <Box width="60%">
                <BlockStack>
                  <TextField
                    label={cms("section.buttonTextColor.label.hexCode")}
                    value={hex.buttonTextHex}
                    onChange={(value) => handleChange(BUTTON_TEXT, value, HEX)}
                    labelAction={
                      hex.buttonTextHex !== DEFAULT_HEADER_COLOR && {
                        content: cms("label.reset"),
                        onClick: () => resetDefault(BUTTON_TEXT, DEFAULT_HEADER_COLOR, HEX),
                      }
                    }
                    error={errorMessage && errorMessage.buttonText}
                  />
                  <br />
                  <Box>
                    <Button variant="primary">{cms("section.buttonTextColor.label.sampleText")}</Button>
                  </Box>
                </BlockStack>
              </Box>
              <ColorPicker onChange={(value) => handleChange(BUTTON_TEXT, value, COLOR)} color={color.buttonText} />
            </InlineStack>
          </Card.Section>
        </Card>
      </Layout.AnnotatedSection>
    </Collapsible>
  );
};

export default withFeature(withErrorBoundary(ButtonText), {
  feature: constant.STANDARD_BRANDING,
});
